"use client";

import dynamic from "next/dynamic";
import { GameIconButton } from "../game-ui";
import { ErrorBoundary } from "../ErrorBoundary";
import { useGame } from "../GameProvider";

const PixiFly = dynamic(() => import("../PixiFly").then((m) => m.PixiFly), {
  ssr: false,
  loading: () => (
    <div className="flex h-full min-h-[280px] items-center justify-center bg-slate-900 text-white">
      <p className="text-lg font-semibold">Loading launch…</p>
    </div>
  ),
});

export function FlyScreen() {
  const { goTo } = useGame();

  return (
    <div className="relative flex h-full min-h-0 flex-1 flex-col">
      <div className="pointer-events-none absolute inset-x-0 top-0 z-20 flex items-start justify-between gap-2 p-2">
        <GameIconButton
          icon="hangar"
          tone="slate"
          size="sm"
          className="pointer-events-auto"
          label="Back to hangar"
          onClick={() => goTo("builder")}
        />
        <GameIconButton
          icon="home"
          tone="slate"
          size="sm"
          className="pointer-events-auto"
          onClick={() => goTo("home")}
        />
      </div>
      <div className="relative min-h-0 flex-1 bg-slate-950">
        <ErrorBoundary label="Launch">
          <PixiFly />
        </ErrorBoundary>
      </div>
    </div>
  );
}
